// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"vZNak","button":"_2G9dT","transcriptionContent":"wcjUT","transcriptionText":"_1yWwi","arrow":"_1z9YE"};